import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { TableRow, TableHeaderCell, TableHeader, TableFooter, TableCell, TableBody, Button, Table, Input, Form, Select } from 'semantic-ui-react';
import { isEqual, uniqueId } from 'lodash';
import { useStore } from '../../app/stores/store';
import { toast } from 'react-toastify';
import { defaultRow } from './smarttrackerType';

interface Props {
  rejectHistoryArr:any[]
  addRows: boolean;
}
export const replacementSubtask = (key: any) => {
  if (key === undefined || key === null) return '';
  switch (key) {
      case 'Quality_Check':
          return 'QC';
      case 'Final_Quality_Analysis':
          return 'FQA';
      case 'Client_Quality_Check':
          return 'CQC';
      case 'Wave_Production':
          return 'W';
      case 'CC_Form_Production':
          return 'CC';
      default:
          return ''; // Return default value or handle other cases accordingly
  }
};

const rejectType = (value: any) => {
  let titleStatus: string = '';
  const titleInput = value?.titleStatus;
  if (typeof titleInput !== 'string') return;
  const title = titleInput.split('_');
  const subtask = replacementSubtask(value?.current_Subtask);
  const containsSubtask = title.includes(subtask);

  if (title.length === 1 || title.length === 2) {
    if (title[0] === subtask || title[0] === 'Wave') {
      titleStatus = `${titleInput}`;
    } else {
      if (containsSubtask) {
        const splitsValue: any = title[1]?.match(/([a-zA-Z]+)(\d+)/);
        titleStatus = `${title[0]}_${splitsValue[1] || ''}${parseInt(splitsValue[2]) + 1}`;
      } else {
        titleStatus = `${titleInput}_${subtask}C1`;
      }
    }
  } else if (title.length === 3) {
    if (containsSubtask) {
      const splitsValue: any = title[2]?.match(/([a-zA-Z]+)(\d+)/);
      titleStatus = `${title[0]}_${title[1]}_${splitsValue[1] || ''}${parseInt(splitsValue[2]) + 1}`;
    } else {
      titleStatus = `${titleInput}_${subtask}C1`;
    }
  } else if (title.length === 4) {
    if (containsSubtask) {
      const splitsValue: any = title[3]?.match(/([a-zA-Z]+)(\d+)/);
      titleStatus = `${title[0]}_${title[1]}_${title[2]}_${splitsValue[1] || ''}${parseInt(splitsValue[2]) + 1}`;
    } else {
      titleStatus = `${titleInput}_${subtask}C1`;
    }
  } else {
    titleStatus = '';
  }

  return titleStatus;
};

const BuildTable: React.FC<Props> = ({ rejectHistoryArr, addRows }) => {
  const { TrackingReportStore,userStore } = useStore();
  const [rowData, setRowData] = useState<{ header: string[], rows: any[] }>({ header: [], rows: [] });

    useEffect(() => {
      // Define the allowed headers
      const allowedHeaders = [
        'rejectid',
        'itemid',
        'operator_empid',
      ];
      // Filter the rejectHistoryArr to only include the allowed headers
      const filteredHistoryArr = rejectHistoryArr?.map(item => {
        const newObject:any = {};
        Object.entries(item).forEach(([key, value]) => {
          if (!allowedHeaders.includes(key.toLowerCase())) {
            newObject[key] = value; // Corrected assignment
          }
        });
        return newObject;
      });
      
      const alignedHistoryArr = filteredHistoryArr?.map(item => {
        const newRow:any = {};
        Object.entries(defaultRow[0]).forEach(([defaultKey, defaultValue]) => {
          newRow[defaultKey] = item[defaultKey] || defaultValue; // Use default value if historyKey is not present
        });
        return newRow;
      });
    // Replace property names and return modified array
              const alignHeaders = alignedHistoryArr?.map(obj => {
                return {
                  "Start Frame": obj.sDefect_SF,
                  "End Frame": obj.sDefect_EF,
                  "Total Frame": obj.sDefect_TF,
                  "defects_Type": obj.defects_Type,
                  position: obj.position,
                  severity: obj.severity,
                  "Reject By" : obj.quality_EmpId,
                  rejecttype: obj.rejectType,
                  qcRemarks:obj.qcRemarks
                };
              });
      const filteredHeaders = Object.keys(alignHeaders[0] || {}).map(header => {
        return header.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
    });
      setRowData({
        header: filteredHeaders,
        rows:
          TrackingReportStore?.bindComponent?.rejectHistory?.length === 0
            ? []
            : alignedHistoryArr,
      });
          // eslint-disable-next-line
  }, [rejectHistoryArr]);


  useEffect(() => {
if(TrackingReportStore?.bindComponent?.defects?.length === 0) return; 
const TitleStatus = rejectType(TrackingReportStore?.bindComponent)

    const updateRejectType = TrackingReportStore?.bindComponent?.defects.map((item: any) => ({ ...item, rejectType: TitleStatus,quality_EmpId:userStore.user?.displayName }));
  TrackingReportStore.bindComponent={
    ...TrackingReportStore.bindComponent,
    defects:updateRejectType,
  }
      // eslint-disable-next-line
}, [TrackingReportStore?.ActiveRowId]);

  useEffect(()=>{
    if(TrackingReportStore?.bindComponent?.defects?.length === 0) return;
    if(userStore?.user?.roleName !== 'Operator'){
     const payload =  {
        ...defaultRow[0],
        quality_EmpId: userStore?.user?.displayName,
      }
  
      TrackingReportStore.bindComponent={
        ...TrackingReportStore.bindComponent,
        defects:[payload],
      }
  
    }
        // eslint-disable-next-line
  },[])

  
  const addRow = () => {
    const temp = [...TrackingReportStore?.bindComponent?.defects];
    const toastValue = temp.some(defect =>
      isEqual(defect, defaultRow[0])
    );

  if (toastValue) {
    toast.warning('Kindly enter previous row.');
    return;
}

const TitleStatus = rejectType(TrackingReportStore?.bindComponent)

// let titleStatus: string = '';
// const titleInput = TrackingReportStore?.bindComponent?.titleStatus;
// if(typeof titleInput !== 'string') return;
// const title = titleInput?.split('_');

//  const subtask = replacementSubtask(TrackingReportStore?.bindComponent?.current_Subtask);
// if(title[0].includes(subtask)){
//   titleStatus = `${title}`
// }
// else{
//   if(titleInput.includes(subtask)){
//   const splitsValue:any = title[1]?.match(/([a-zA-Z]+)(\d+)/);
//     titleStatus = `${title[0]}_${splitsValue[1] || ''}${parseInt(splitsValue[2]) + 1}`;
//   }else{
//        titleStatus = `${titleInput}_${subtask}C1`
//   }
// }

  const addrows = {
    ...defaultRow[0],
    quality_EmpId: userStore?.user?.displayName,
    rejectType: TitleStatus
  }
  temp.push(addrows)
  TrackingReportStore.bindComponent={
    ...TrackingReportStore.bindComponent,
    defects: temp
  }
  };
  
  const handleChange = (value: string, rowIndex: number, name: any) => {
    if (addRows) {  

      const updatedRows:any[] = [...TrackingReportStore?.bindComponent?.defects];  
      const updateFrame = () => {
        const sDefect_EF = parseInt(updatedRows[rowIndex]['sDefect_EF'] || '0');
        const sDefect_SF = parseInt(updatedRows[rowIndex]['sDefect_SF'] || '0');
        updatedRows[rowIndex]['sDefect_TF'] = (sDefect_EF - sDefect_SF + 1) || 0;
        if(updatedRows[rowIndex]['sDefect_SF'] === 0 && updatedRows[rowIndex]['sDefect_EF'] === 0)  updatedRows[rowIndex]['sDefect_TF'] = 0;
        if (updatedRows[rowIndex]['sDefect_TF'] < 0) {
            updatedRows[rowIndex]['sDefect_TF'] = 0;
        }
    };
    
      if (["sDefect_SF", "sDefect_EF", "sDefect_TF", 'rejectDate'].includes(name)) {
        const parsedValue = parseFloat(value);  
        if (!isNaN(parsedValue) || value === '') {
          updatedRows[rowIndex] = {
            ...updatedRows[rowIndex], // Make a copy of the row object
            [name]: value === '' ? '' : parsedValue
          };
          updateFrame();
        }
      } else {
        updatedRows[rowIndex] = {
          ...updatedRows[rowIndex], // Make a copy of the row object
          [name]: value
        };
      }
      TrackingReportStore.bindComponent={
        ...TrackingReportStore.bindComponent,
        defects: updatedRows
      }
    } 
  };
  

  const removeRow = (indexToRemove: number) => {
    TrackingReportStore.bindComponent = {
      ...TrackingReportStore.bindComponent,
      defects:TrackingReportStore?.bindComponent?.defects.filter((row,index) => index !== indexToRemove)
    }
  };


  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <Table celled compact style={{ width: '80%' }}>
        <TableHeader fullWidth>
          <TableRow>
            {rowData.header.map((header, index) => (
              <TableHeaderCell key={index}>{header}</TableHeaderCell>
            ))}
            <TableHeaderCell></TableHeaderCell>
          </TableRow>
        </TableHeader>

        <TableBody>
          {(rowData.rows || []).map((row: any, rowIndex: number) => (
            <TableRow key={rowIndex}>
              {Object.entries(row).map(([key, value], colIndex: number) => (
                <TableCell key={colIndex}>{value}</TableCell>
              ))}
              <TableCell></TableCell>
            </TableRow>
          ))}
          {(TrackingReportStore?.bindComponent?.defects || []).map(
            (row: any, rowIndex: number) => (
              <TableRow key={rowIndex}>
                {Object.entries(row).map(([key, value], colIndex: number) => (
                  <TableCell key={colIndex}>
                    {key === 'defects_Type' || key === 'severity' ? (
                      <Select
                        value={value as string}
                        onChange={(e: any, data: any) =>
                          handleChange(data.value, rowIndex, key)
                        }
                        options={
                          key === 'defects_Type'
                            ? TrackingReportStore.DefectTypeSeverity.DefectTypes
                            : key === 'severity'
                              ? TrackingReportStore.DefectTypeSeverity.Severity
                              : []
                        }
                        placeholder={`Select an Option`}
                        isSearchable
                        search
                        clearable
                      />
                    ) : key === 'qcRemarks'? (
                      <Form.TextArea
                      className='table-textArea'
                      value={value as string || ''}
                      onChange={(e: any) =>
                        handleChange(e.target.value, rowIndex, key)
                      }
                      id={uniqueId()}
                      placeholder={`Please enter ${rowData?.header[colIndex]?.toLocaleLowerCase()}`}
                    />
                      ): (
                      <Form.Field
                        readOnly={[
                          'sDefect_TF',
                          'quality_EmpId',  
                          'rejectType',
                        ].includes(key)}
                        required={true}
                        id={uniqueId()}
                        control={Input}
                        value={value}
                        placeholder={`Please enter ${rowData?.header[colIndex]?.toLocaleLowerCase()}`}
                        onChange={(e: any) =>
                          handleChange(e.target.value, rowIndex, key)
                        }
                      />
                    )}
                  </TableCell>
                ))}

                <TableCell>
                  {addRows && (
                    <Button
                      icon="trash"
                      color="grey"
                      onClick={() => removeRow(rowIndex)}
                    />
                  )}
                </TableCell>
              </TableRow>
            ),
          )}
        </TableBody>

        <TableFooter fullWidth>
          <TableRow>
            <TableHeaderCell></TableHeaderCell>
            <TableHeaderCell colSpan={rowData.header.length}>
              {addRows && (
                <Button
                  floated="right"
                  icon
                  primary
                  size="small"
                  onClick={addRow}
                >
                  Add Row
                </Button>
              )}
            </TableHeaderCell>
          </TableRow>
        </TableFooter>
      </Table>
    </div>
  );
};

export default observer(BuildTable);